import axios from "axios";
import store from "../../redux/store";
import { toastr } from "react-redux-toastr";
import { getRefreshToken } from "../constants/checkAuth";
import { getCashierRefreshToken } from "../constants/checkCashierAuth";
import { refreshCashierAuthCall } from "../../redux/actions/cashierActions";
import { logoutCall, refreshAuthCall } from "../../redux/actions/authActions";

const Urls = {
  baseUrl: import.meta.env.VITE_API_URL,
};

export const rootUrl = Urls;

const Api = axios.create({
  baseURL: rootUrl.baseUrl,
});

export const cashierApi = axios.create({
  baseURL: rootUrl.baseUrl,
});

let isAuthRefreshing = false;
let refreshAuthSubscribers = [];

function onAccessTokenFetched(access_token) {
  refreshAuthSubscribers = refreshAuthSubscribers.filter((callback) =>
    callback(access_token)
  );
}

function addSubscriber(callback) {
  refreshAuthSubscribers.push(callback);
}

Api.interceptors.request.use(
  (req) => {
    if (window.navigator.onLine) {
      const accessToken =
        localStorage?.accessToken &&
        JSON.parse(localStorage?.accessToken)?.token;

      if (accessToken?.length > 0) {
        req.headers = {
          Authorization: `Bearer ${accessToken}`,
        };
      }
      return req;
    } else {
      toastr.error("Error", "You are not connected to internet");
    }
    return req;
  },
  (err) => Promise.reject(err)
);

Api.interceptors.response.use(
  (response) => response,
  (error) => {
    const config = error.response?.config;
    const data = error.response?.data;
    const code = data?.code;
    const message = data?.message;
    const originalRequest = config;

    if (code === 401 && message === "Please authenticate") {
      if (!isAuthRefreshing) {
        const refreshToken = getRefreshToken();

        if (refreshToken?.length > 0) {
          isAuthRefreshing = true;
          store
            .dispatch(
              refreshAuthCall({
                refreshToken,
              })
            )
            .then((token) => {
              isAuthRefreshing = false;
              onAccessTokenFetched(token);
            });
        } else {
          store.dispatch(logoutCall());
        }
      }

      return new Promise((resolve) => {
        addSubscriber((access_token) => {
          originalRequest.headers.Authorization = "Bearer " + access_token;
          resolve(Api(originalRequest));
        });
      });
    }
    return Promise.reject(error);
  }
);

let isCashierRefreshing = false;
let refreshCashierSubscribers = [];

function onAccessTokenFetched2(access_token) {
  refreshCashierSubscribers = refreshCashierSubscribers.filter((callback) =>
    callback(access_token)
  );
}

function addSubscriber2(callback) {
  refreshCashierSubscribers.push(callback);
}

cashierApi.interceptors.request.use(
  (req) => {
    if (window.navigator.onLine) {
      return req;
    } else {
      toastr.error("Error", "You are not connected to internet");
    }
    return req;
  },
  (err) => Promise.reject(err)
);

cashierApi.interceptors.response.use(
  (response) => response,
  (error) => {
    const config = error.response?.config;
    const data = error.response?.data;
    const code = data?.code;
    const message = data?.message;
    const originalRequest = config;

    if (code === 401 && message === "Please authenticate") {
      if (!isCashierRefreshing) {
        isCashierRefreshing = true;
        store
          .dispatch(
            refreshCashierAuthCall({
              refreshToken: getCashierRefreshToken(),
            })
          )
          .then((token) => {
            isCashierRefreshing = false;
            onAccessTokenFetched2(token);
          });
      }

      return new Promise((resolve) => {
        addSubscriber2((access_token) => {
          originalRequest.headers.Authorization = "Bearer " + access_token;
          resolve(cashierApi(originalRequest));
        });
      });
    }
    return Promise.reject(error);
  }
);

export default Api;
